import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../store/hooks';
import { logout } from '../store/slices/authSlice';
import { isJwtExpired } from '../auth/jwt/tokenUtils';

interface PrivateRouteProps {
    children: React.ReactNode;
}

const isAllowedFrontendRole = (role?: string) => role === 'user' || role === 'trainer';

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
    const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
    const user = useAppSelector((state) => state.auth.user);
    const token = useAppSelector((state) => state.auth.token);
    const dispatch = useAppDispatch();
    const isTokenValid = !!token && !isJwtExpired(token);

    useEffect(() => {
        if (!isAuthenticated || !isTokenValid || !isAllowedFrontendRole(user?.role)) {
            dispatch(logout());
        }
    }, [isAuthenticated, isTokenValid, user, dispatch]);

    if (!isAuthenticated || !isTokenValid) {
        return <Navigate to="/login" replace />;
    }

    if (!isAllowedFrontendRole(user?.role)) {
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
};

export default PrivateRoute;
